import { useEffect, useState } from 'react';

const BASE = 'notaryos_active_matter';
const EVT = 'active-matter-change';
let uid = '';

const key = () => `${BASE}:${uid}`;

export const setActiveMatterUser = (id) => {
  if ((id || '') === uid) return;
  uid = id || '';
  setTimeout(() => window.dispatchEvent(new Event(EVT)), 0);
};

export const getActiveMatter = () => {
  if (!uid) return null;
  try { return JSON.parse(localStorage.getItem(key()) || 'null'); } catch { return null; }
};

export const setActiveMatter = (m) => {
  if (!uid) return;
  if (m) localStorage.setItem(key(), JSON.stringify({ id: m.id, title: m.title, matter_type: m.matter_type, country: m.country }));
  else localStorage.removeItem(key());
  window.dispatchEvent(new Event(EVT));
};

// Drop the active case if it no longer exists among the user's matters
export const validateActiveMatter = (matters) => {
  const a = getActiveMatter();
  if (a && !matters.some((m) => m.id === a.id)) setActiveMatter(null);
};

// Active case shared across Cerebro, CRM and agents (per user, persists between pages and sessions)
export const useActiveMatter = () => {
  const [m, setM] = useState(getActiveMatter);
  useEffect(() => {
    const on = () => setM(getActiveMatter());
    on();
    window.addEventListener(EVT, on);
    window.addEventListener('storage', on);
    return () => { window.removeEventListener(EVT, on); window.removeEventListener('storage', on); };
  }, []);
  return [m, setActiveMatter];
};
